import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    position: 'relative',
  },

  card: {
    width: '100%',
    padding: 0,
    margin: 0,
    borderRadius: '0.5rem !important',
    border: `1px solid ${theme.palette.secondary.light}`,
    overflow: 'hidden',
  },

  iframe: {
    width: '100%',
    height: 'max-content',
    minHeight: '100vh',
    border: 'none',
    outline: 'none',
    margin: 0,
    padding: 0,
  },
}))

export { useStyles }
